import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { env } from "@/utils/env";
import PencomHeader from "./PencomHeader";
import { PencomFooter } from "./PencomFooter";
import ScrollToTop from "@/components/common/ScrollToTop";

const PencomLayout = () => {
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;

    // Handle dynamic routes
    if (path.startsWith("/employee-contribution-details/")) {
      return "Employee Contribution Details";
    }
    if (path === "/support/tickets") {
      return "All Conversations";
    }
    if (path.startsWith("/support/")) {
      return "Support Ticket";
    }

    switch (path) {
      case "/":
        return "Dashboard";
      case "/contributions":
        return "Contributions";
      case "/add-group-life-insurance":
        return "Add Group Life Insurance";
      case "/available-providers":
        return "Available Providers";
      case "/group-life-insurance":
        return "Group Life Insurance";
      case "/employees":
        return "Employees";
      case "/request-call-back":
        return "Request Call Back";
      case "/add-employee":
        return "Add Employee";
      case "/bulk-upload-employee":
        return "Bulk Upload Employee";
      case "/pcc-certificate":
        return "PCC Certificate";
      case "/apply-for-pcc":
        return "Apply for PCC";
      case "/pcc-application-successful":
        return "PCC Application Successful";
      case "/penalty-breakdown":
        return "Penalty Breakdown";
      case "/support":
        return "Support";
      default:
        return "Dashboard";
    }
  };

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>{`${getPageTitle()} - ${env.APP_NAME}`}</title>
        <meta
          name="description"
          content={`${env.APP_NAME} - A modern React application`}
        />
      </Helmet>

      <div className="flex min-h-screen flex-col bg-off-white">
        <PencomHeader />

        <main className="mx-auto w-full flex-1 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <Outlet />
          </div>
        </main>

        <PencomFooter />
      </div>
    </>
  );
};

export default PencomLayout;
